import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const CenterMap = ({
  width = 36,
  height = 36,
  className,
  color,
  decorative = false,
  ariaLabel = "Center map",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 36 36"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.409 0h2.182v5.455h-2.182zM7.634 17.45c0-5.413 4.404-9.818 9.818-9.818s9.818 4.405 9.818 9.818c0 5.414-4.405 9.819-9.818 9.819-5.414 0-9.818-4.405-9.818-9.819m1.784 0c0 4.43 3.604 8.034 8.034 8.034s8.033-3.604 8.033-8.034-3.604-8.033-8.033-8.033c-4.43 0-8.034 3.604-8.034 8.033m3.175.052a4.915 4.915 0 0 1 4.909-4.909 4.914 4.914 0 0 1 4.909 4.91 4.915 4.915 0 0 1-4.91 4.908 4.915 4.915 0 0 1-4.909-4.909m1.748 0a3.164 3.164 0 0 0 3.16 3.16 3.164 3.164 0 0 0 3.161-3.16 3.164 3.164 0 0 0-3.16-3.16 3.164 3.164 0 0 0-3.161 3.16m4.25 13.044h-2.182V36h2.182zm16.517-14.137v1.929h-5.657v-1.929zM5.657 18.338v-1.929H0v1.929z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
